module.exports = __webpack_public_path__ + "static/media/default-dark.8a303ef5.svg";